import { ButtonColorProp } from '../properties';
import { ColorType } from '../types';

export function getButtonColor(color?: ColorType) {
  if (!color) return '';

  return ButtonColorProp[color];
}
